(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personality-quiz"] && !Shopify.designMode) return;
  try {
    
(function() {
  const quizSections = {};

  function setupPersonalityQuiz(container) {
    if (!container) return;
    const sectionId = container.dataset.sectionId;
    if (!sectionId || quizSections[sectionId]) {
      return;
    }
    
    const leadFormEnabled = container.dataset.leadFormEnabled === 'true';
    const totalQuestions = parseInt(container.dataset.totalQuestions, 10);

    const getResultBtn = container.querySelector(`#get-result-btn-${sectionId}`);
    const restartBtn = container.querySelector(`#restart-quiz-btn-${sectionId}`);
    const questionsWrapper = container.querySelector('.quiz-questions-wrapper');
    const resultsWrapper = container.querySelector('.quiz-results-wrapper');
    const errorMsg = container.querySelector(`#quiz-error-${sectionId}`);
    const leadFormWrapper = container.querySelector(`#lead-form-wrapper-${sectionId}`);
    const leadForm = leadFormWrapper ? leadFormWrapper.querySelector('.quiz-lead-form') : null;

    if (!getResultBtn || !questionsWrapper) {
      return;
    }
    
    const quizInstance = {
      sectionId: sectionId,
      calculateAndShowResult: function() {
        const checkedRadios = questionsWrapper.querySelectorAll('input[type="radio"]:checked');
        const scores = {};
        checkedRadios.forEach(radio => {
          const personality = radio.dataset.personality;
          if (personality) { scores[personality] = (scores[personality] || 0) + 1; }
        });
        
        let topPersonality = '';
        let maxScore = -1;
        for (const personality in scores) {
          if (scores[personality] > maxScore) {
            maxScore = scores[personality];
            topPersonality = personality;
          }
        }
    
        if(leadFormWrapper) leadFormWrapper.style.display = 'none';
        questionsWrapper.style.display = 'none';
        getResultBtn.style.display = 'none';
        errorMsg.style.display = 'none';
        resultsWrapper.style.display = 'block';
        const resultToShow = container.querySelector(`#result-${topPersonality}-${sectionId}`);
        if (resultToShow) { resultToShow.style.display = 'block'; }
        restartBtn.style.display = 'inline-block';
      },
      init: function() {
        getResultBtn.addEventListener('click', () => {
          const checkedRadios = questionsWrapper.querySelectorAll('input[type="radio"]:checked');
          if (checkedRadios.length < totalQuestions) {
            errorMsg.style.display = 'block';
            return;
          }
          errorMsg.style.display = 'none';
          
          if (leadFormEnabled) {
            questionsWrapper.style.display = 'none';
            getResultBtn.style.display = 'none';
            leadFormWrapper.style.display = 'block';
            leadFormWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            this.calculateAndShowResult();
          }
        });
        
        if (leadForm) {
          leadForm.addEventListener('submit', () => {
            const answers = Array.from(questionsWrapper.querySelectorAll('input[type="radio"]:checked')).map(radio => radio.dataset.personality);
            sessionStorage.setItem(`quizAnswers-${sectionId}`, JSON.stringify(answers));
          });
        }
        
        restartBtn.addEventListener('click', () => {
            const allRadios = questionsWrapper.querySelectorAll('input[type="radio"]');
            allRadios.forEach(radio => radio.checked = false);
            const allResults = resultsWrapper.querySelectorAll('.quiz-result');
            allResults.forEach(result => result.style.display = 'none');
            resultsWrapper.style.display = 'none';
            restartBtn.style.display = 'none';
            if (leadFormWrapper) leadFormWrapper.style.display = 'none';
            questionsWrapper.style.display = 'block';
            getResultBtn.style.display = 'inline-block';
            container.scrollIntoView({ behavior: 'smooth' });
        });

        const urlParams = new URLSearchParams(window.location.search);
        const formPosted = urlParams.has('customer_posted');
        const storedAnswersRaw = sessionStorage.getItem(`quizAnswers-${sectionId}`);
        if (formPosted && storedAnswersRaw) {
          const storedAnswers = JSON.parse(storedAnswersRaw);
          const scores = {};
          storedAnswers.forEach(personality => { scores[personality] = (scores[personality] || 0) + 1; });
          let topPersonality = '';
          let maxScore = -1;
          for (const personality in scores) { if (scores[personality] > maxScore) { maxScore = scores[personality]; topPersonality = personality; } }
          questionsWrapper.style.display = 'none';
          getResultBtn.style.display = 'none';
          if(leadFormWrapper) leadFormWrapper.style.display = 'none';
          resultsWrapper.style.display = 'block';
          const resultToShow = container.querySelector(`#result-${topPersonality}-${sectionId}`);
          if (resultToShow) {
            resultToShow.style.display = 'block';
            resultsWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          restartBtn.style.display = 'inline-block';
          sessionStorage.removeItem(`quizAnswers-${sectionId}`);
        }
      }
    };
    
    quizInstance.init();
    quizSections[sectionId] = quizInstance;
  }

  function loadQuizzes(container) {
    const quizContainers = container ? container.querySelectorAll('.quiz-outer-wrapper[data-section-id]') : document.querySelectorAll('.quiz-outer-wrapper[data-section-id]');
    quizContainers.forEach(setupPersonalityQuiz);
  }

  document.addEventListener('DOMContentLoaded', () => {
    loadQuizzes(document);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('quiz-outer-wrapper')) {
        setupPersonalityQuiz(event.target);
      }
    });
    document.addEventListener('shopify:section:reorder', () => {
      Object.keys(quizSections).forEach(key => delete quizSections[key]);
      loadQuizzes(document);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
